import { useRef, useEffect } from "react";

/**
 * useLume - Ferrari 2026 Core Hook
 * Monitors mouse coordinates and updates CSS Custom Properties on a ref.
 * Bypasses React state for zero-latency visual reactivity.
 */
export const useLume = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleMouseMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Update CSS variables directly for GPU performance
      el.style.setProperty("--lume-x", `${x}px`);
      el.style.setProperty("--lume-y", `${y}px`);
      el.style.setProperty("--lume-opacity", "1");
    };

    const handleMouseLeave = () => {
      el.style.setProperty("--lume-opacity", "0");
    };

    el.addEventListener("mousemove", handleMouseMove);
    el.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      el.removeEventListener("mousemove", handleMouseMove);
      el.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return ref;
};

export default useLume;
